// extracted by mini-css-extract-plugin
export default {"badge":"Badge_badge__9SpX+","badgeMargin":"Badge_badgeMargin__cAs9g"};